import React from 'react';
import { SummaryBox } from './style';
import NumberFormat from 'react-number-format';

const SummaryWallet = ({ title, value }) => {
    return (
        <SummaryBox>
            <h3>{ title }</h3>

            <div className="center">
                <p>Balance: <NumberFormat id="balance" value={value} displayType={'text'} thousandSeparator={true}  /></p>
            </div>
        </SummaryBox>
    );
};

export default SummaryWallet;


